import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Moment} from 'moment-timezone';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {limitDecimals} from '../../../../../shared/ec-economics';

export interface BilledData {
    plantRei: number;
    plantInjected: number;
}

@Component({
    selector: 'app-set-billed-data',
    templateUrl: './set-billed-data.component.html',
    styleUrls: ['./set-billed-data.component.scss']
})
export class SetBilledDataComponent implements OnInit {
    @Input() date: Moment;
    @Output() values: EventEmitter<BilledData> = new EventEmitter<BilledData>();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();

    form: FormGroup;
    year: number;

    readonly limitDecimals = limitDecimals;

    constructor(private readonly fb: FormBuilder) {
        this.form = this.fb.group({
            plantRei: new FormControl(null, [Validators.required]),
            plantInjected: new FormControl(null)
        });
    }

    ngOnInit(): void {
        this.year = this.date.year();
        this.form.valueChanges
            .pipe(debounceTime(500))
            .subscribe((val) => {
                const bd: BilledData = {
                    plantRei: val.plantRei,
                    plantInjected: val.plantInjected
                };
                this.values.next(bd);
                this.valid.next(this.form.valid);
            });
    }

}
